export const INTERNATIONAL_CURRENCY_SUBUNITS_NAMES = {
  GBP: "pence",
  USD: "cent",
  AUD: "cent",
  NZD: "cent",
};
